var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"link",staticStyle:{"cursor":"pointer"},on:{"click":function($event){return _vm.f_go_main()}}},[(_vm.logo_color == 'color')?_c('v-img',{attrs:{"src":require('../assets/main_logo_color.svg')}}):_vm._e(),(_vm.logo_color == 'white')?_c('v-img',{attrs:{"src":require('../assets/main_logo_white.svg')}}):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }